const mutations = {
    login(state, data) {
        const user = data.user
        state.loginFailed = false
        state.firstName = user.firstName
        state.userId = user.uid
        state.userRole = user.role
        state.restrictions = user.restrictions
        state.allowedDates = user.deliveryDays
        state.permissions = user.permissions
        localStorage.setItem('restrictions', JSON.stringify(user.restrictions))
        localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem('permissions', JSON.stringify(user.permissions))
        state.excludePartialItems = user.excludePartialItems

        const currentDate = new Date();
        currentDate.setMinutes(currentDate.getMinutes() + 60);
        user['expiration'] = currentDate;

        if(user.restrictions.pw !== 0) {
            state.logged = true
            state.headerText = "Willkommen " + user.firstName + ",<br/> was möchtest du tun?"

            state.cartContentCounter = user.cartContent === null ? 0 : JSON.parse(user.cartContent).length
            state.lastWatched = user.lastWatched === null ? [] : user.lastWatched
            state.watchlist = user.watchlist === null ? [] : JSON.parse(user.watchlist)

        }


        if(Object.keys(data).indexOf('token') !== -1) {
            const bearerToken = {}
            bearerToken.token = data.token
            bearerToken.expiration = currentDate
            localStorage.setItem('token', JSON.stringify(bearerToken))
        }

        state.user = user
    },

    loginFailed(state) {
        state.loginFailed = true
    },

    logout(state) {
        state.logged = false
        state.loginFailed = false

        state.token = null
        state.user = null

        state.headerText= 'Bitte melde dich an.'

        state.cartContent = []
        state.lastWatched = []
        state.permissions = []

        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('restrictions')
        localStorage.removeItem('currentDeposit')
        localStorage.removeItem('depositValues')
        localStorage.removeItem('permissions')
        localStorage.removeItem('currentActiveMode')
    },

    closeSnackbar(state, data) {
        state.loginFailed = data;
    },

    setHeaderVisibility(state, data) {
        state.headerVisibility = data;
    },

    setOverlay(state, data) {
        state.overlayVisibility = data.visibility;
        state.overlayContent = data.state
    },

    setCartContent(state, data) {
      state.cartContents = data.data
    },

    addToCart(state, data) {
        state.cartContentCounter = data.data.length
    },

    removeFromCart(state, data) {
        state.cartContentCounter = data.data.length
    },

    overwriteCartContent(state, data) {
        state.cartContentCounter = data.data.length
    },

    updateTotalCartPrice(state, data) {
        state.totalPrice -= data
    },

    returnSearch(state, data) {
        state.searchResult = data.data
    },

    setLastWatched(state, data) {
        state.lastWatched = data.data
    },

    setWatchList(state, data) {
        state.watchlist = data.data
    },

    setDrawerVisibility(state) {
        state.drawerVisibility = !state.drawerVisibility
    },

    retrieveCartContent(state, data) {
        state.cartContents = data.data.cartContent
        state.totalPrice = data.data.totalPrice
    },

    setLoadingState(state, data) {
        state.isLoading = data
    },

    setCategoryBreadcrumbs(state, data) {
        if(data === null) {
            state.categoryBreadcrumbs.length = 0
        }
        else {
            state.categoryBreadcrumbs.push(data)
        }

    },

    setSideDrawerState(state) {
        state.sideDrawerState = !state.sideDrawerState
    },

    setCartDrawerState(state) {
        state.cartDrawerState = !state.cartDrawerState
    },

    setBarcodeScannerState(state) {
        state.barcodeScannerState = !state.barcodeScannerState
    },

    setDepositCollector(state, data) {
        state.depositCollector.push(data)
        var crate = data.depositType
        var internalDepositType = data.internalDepositType
        if(crate === 'c') {

            if('0' in state.depositOverview) {
                state.depositOverview[0] += data.depositAmount
            }
            else {
                state.depositOverview[0] = data.depositAmount
            }

            if(internalDepositType in state.depositOverview) {
                state.depositOverview[internalDepositType] += (data.depositAmount * data.amountIfCrate)

            }
            else {
                state.depositOverview[internalDepositType] = data.depositAmount * data.amountIfCrate
            }
        }
        else {
            if(internalDepositType in state.depositOverview) {
                state.depositOverview[internalDepositType] += (data.depositAmount * data.amountIfCrate)
            }
            else {
                state.depositOverview[internalDepositType] = data.depositAmount
            }
        }
    },

    setDepositCollectorOnList(state, data) {
      state.depositCollector = data
    },

    setDepositStartCheck(state, data) {
      state.depositStartCheck = data
    },

    setContinuedDeposit(state, data) {
      state.continuedDeposit = data
    },

    setDepositReset(state, data) {
        state.depositReset = data
    },

    sendDepositCollection(state) {
        state.signatureSVG = null
        localStorage.removeItem('currentDeposit')
    },

    setNotificationTxt(state, data) {
        state.notificationTxt = data
    },

    setShowNotification(state) {
        state.showNotification = !state.showNotification
    },

    setCategories(state, data) {
        state.categories = data
    },

    setCurrentCategory(state, data) {
        state.currentCategory = data
    },

    setSignaturePadState(state) {
        state.signaturePadState = !state.signaturePadState
    },

    setDepositOverlay(state, data) {
        state.depositOverlayVisibility = data.visibility;
        state.depositOverlayContent = data.state
    },

    setSignatureSVG(state, data) {
        state.signatureSVG = data
    },

    emptyCommit() {

    },

    resetCart(state) {
        state.cartContents.length = 0
        state.cartContentCounter = 0
    },

    setOrder(state, data) {
        state.order = data
    },

    setIssueMore(state, data) {
        state.issueMore = data
    },

    setCurrentCategoryPosition(state, data) {
        if(data !== false) {
            state.currentCategoryPosition.push(data)
        }
        else {
            state.currentCategoryPosition.pop()
        }
    },

    setCurrentPosition(state, data) {
        state.currentPosition = data
    },

    resetCurrentPosition(state) {
        state.currentPosition = null
    },

    setStoredCategoryProducts(state, data) {
        state.storedCategoryProducts.push(data)
    },

    resetStoredCategoryProducts(state) {
        state.storedCategoryProducts.length = 0
    },

    setCurrentPage(state, data) {
        state.currentPage = data
    },

    setTopScroll(state, data) {
        state.topScroll = data
    },

    setSearchResultsArticles(state, data) {
        state.searchResultsArticles = data
    },

    setNewsAvailableState(state, data) {
        state.newsAvailable = data
    },

    setCurrentActiveMode(state, data) {
        if(state.currentActiveMode === data) {
            state.currentActiveMode = null
            localStorage.removeItem('currentActiveMode')
        } else {
            state.currentActiveMode = data
            localStorage.setItem('currentActiveMode', data)
        }
    },


    setRequestStateTourData(state, data) {
      state.requestStateTourData = data
    },
    setRequestPendingTourData(state, data) {
      state.requestPendingTourData = data
    },
    setLoadingOverlayTourData(state, data) {
      state.loadingOverlayTourData = data
    }
}

export default mutations
